export default __webpack_public_path__ + "static/media/NextPageIcon.816ef9ba.svg";